import type { RequestOptions } from "../types/requestOptions";
import { authenticationService } from "./authentication-service";

// One blob URL per image id for the app's lifetime. Callers never revoke, so
// re-materializing per mount/poll pinned a new Blob each time (MCS-4316).
// Failed fetches are not cached so they can retry.
const imageUrlCache = new Map<string, Promise<string>>();

export function getImageSrc(id: string): Promise<string> {
  const cached = imageUrlCache.get(id);
  if (cached) return cached;

  const requestOptions: RequestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: `Bearer ${authenticationService.currentUserValue.token}`,
    },
    cache: "force-cache",
  };

  const pending = (async () => {
    const reqUrl = `/api/v1/saas/image-files/${id}`;
    const response = await fetch(reqUrl, requestOptions);
    // fetch resolves on HTTP errors - without this a transient 401/500 body
    // would be cached as the image for the rest of the session
    if (!response.ok) {
      throw new Error(`Image fetch failed for ${id}: ${response.status}`);
    }
    return URL.createObjectURL(await response.blob());
  })().catch((error) => {
    imageUrlCache.delete(id);
    throw error;
  });

  imageUrlCache.set(id, pending);
  return pending;
}
